"use strict";

angular.module('app.modals.sceneTimeProgramFineEdit', [])

    .controller('sceneTimeProgramFineEditModalCtrl', [
        '$scope', 'close', 'Condition', 'Day', '$filter', 'dateTimePickerModal', 'ConnectedDays',
        function($scope, close, Condition, Day, $filter, dateTimePickerModal, ConnectedDays) {
            $scope.WeekDaysArray = [
                { 'Tag':  'mo', 'WeekDay': 1 },
                { 'Tag': 'tue', 'WeekDay': 2 },
                { 'Tag': 'wed', 'WeekDay': 3 },
                { 'Tag': 'thu', 'WeekDay': 4 },
                { 'Tag': 'fri', 'WeekDay': 5 },
                { 'Tag': 'sat', 'WeekDay': 6 },
                { 'Tag': 'sun', 'WeekDay': 0 }
            ];

            $scope.HoursArray = [];
            for (var i = 0; i <= 24; i++) {
                $scope.HoursArray.push({
                    'hour': i
                });
            }
            $scope.init = function() {
                $scope.ConnectedDays = [];
                $scope.Condition = {
                    ConditionData: {
                        TimeProgram: Condition
                    }
                };
                if (ConnectedDays) {

                    for (var key in ConnectedDays) {
                        if (ConnectedDays.hasOwnProperty(key)) {
                            $scope.ConnectedDays.push(ConnectedDays[key]);
                        }
                    }
                    
                    $scope.ConnectedDays = $filter('orderBy')($scope.ConnectedDays, 'WeekDay');

                }

                //,function(a){return ConnectedDays[a];});


                $scope.Day = Day;

                $scope.cleanupEntrys($scope.Condition.ConditionData.TimeProgram.WeekProgramEntries);
                $scope.Condition.ConditionData.TimeProgram.WeekProgramEntries = $filter('orderBy')($scope.Condition.ConditionData.TimeProgram.WeekProgramEntries, '+Start');

                const wpes = $scope.Condition.ConditionData.TimeProgram.WeekProgramEntries;
                if (wpes.length > 0) {
                    wpes.forEach(wpe => {
                        ['Start', 'End'].forEach(dateVar => {
                            if (moment(wpe.ReferenceDay).set({ 'milliseconds': 0, 'seconds': 0, 'minutes': 0, 'hours': 24 }).isSame(wpe[dateVar])) {
                                wpe['IsNextDay' + dateVar] = true;
                            } else {
                                wpe['IsNextDay' + dateVar] = false;
                            }
                        });
                    });
                }

            };
            // $scope.$watch('Condition.ConditionData.TimeProgram.WeekProgramEntries', function() {
            //     //$scope.TimeEntrys = $filter('filter')($scope.Condition.ConditionData.TimeProgram.WeekProgramEntries,{'WeekDay':Day.WeekDay});
            //
            // });
            $scope.close = function(WeekProgramEntries) {
                if (WeekProgramEntries && WeekProgramEntries.length > 1) {
                    $scope.cleanupEntrys(WeekProgramEntries);

                }

                close(WeekProgramEntries);
            };

            function isBefore(a, b) {
                return a.time.isSameOrBefore(b.time);
            }

            function isAfter(a, b) {
                return a.time.isSameOrAfter(b.time);
            }
            $scope.cleanupEntrys = function(WeekProgramEntries) {

                /* function isBefore(a,b){
                     return moment(a).isBefore(b);
                 }*/

                for (var j = (WeekProgramEntries.length - 1); j >= 0; j--) {
                    if (WeekProgramEntries[j].WeekDay != $scope.Day.WeekDay) {
                        continue;
                    }

                    for (var i = (WeekProgramEntries.length - 1); i >= 0; i--) {

                        if ((i === j)
                            || WeekProgramEntries[i] == undefined
                            || WeekProgramEntries[j] == undefined
                            || WeekProgramEntries[i].WeekDay != $scope.Day.WeekDay) {
                            continue;
                        }

                        var a = WeekProgramEntries[j];
                        var aStart = { time: a.Start, astroType: a.AstroTypeStart || 0 };
                        var aEnd = { time: a.End, astroType: a.AstroTypeEnd || 0 };
                        let b = WeekProgramEntries[i];
                        var bStart = { time: b.Start, astroType: b.AstroTypeStart || 0 };
                        var bEnd = { time: b.End, astroType: b.AstroTypeEnd || 0 };

                        ////////////////////////////////
                        // a:    ---------xxxxxxxxxxxxxxxxxxx-------
                        // b:    ------------xxxxxxxxxxxxxx---------
                        // = use a
                        if (isBefore(aStart, bStart) && isAfter(aEnd, bEnd) && bStart.astroType === 0 && bEnd.astroType === 0) {
                            WeekProgramEntries.splice(i, 1);
                            continue;
                        }

                        ////////////////////////////////
                        // a:    ------------xxxxxxxxxxxxxx---------
                        // b:    ---------xxxxxxxxxxxxxxxxxxx-------
                        // = set a to b and splice b
                        if (isBefore(bStart, aStart) && isAfter(bEnd, aEnd) && aStart.astroType === 0 && aEnd.astroType === 0) {
                            a.AstroIconStart = b.AstroIconStart;
                            a.AstroIconEnd = b.AstroIconEnd;
                            a.AstroOffsetStart = b.AstroOffsetStart;
                            a.AstroOffsetEnd = b.AstroOffsetEnd;
                            a.AstroTypeStart = b.AstroTypeStart;
                            a.AstroTypeEnd = b.AstroTypeEnd;

                            a.Start = b.Start;
                            a.End = b.End;
                            WeekProgramEntries.splice(i, 1);
                            continue;
                        }

                        ////////////////////////////////
                        // a:    ---xxxxxxxxxxxxxx------------------
                        // b:    ---------xxxxxxxxxxxxxxxxxxx-------
                        // = a union b
                        if (isBefore(aStart, bStart) && isAfter(bEnd, aEnd) && isAfter(aEnd, bStart) && aEnd.astroType === 0 && bStart.astroType === 0) {
                            a.AstroIconEnd = b.AstroIconEnd;
                            a.AstroOffsetEnd = b.AstroOffsetEnd;
                            a.AstroTypeEnd = b.AstroTypeEnd;
                            a.End = b.End;
                            WeekProgramEntries.splice(i, 1);
                            continue;
                        }


                        ////////////////////////////////
                        // a:    ---------xxxxxxxxxxxxxxxxxxx-------
                        // b:    ---xxxxxxxxxxxxxx------------------
                        // = a union b
                        if (isAfter(aStart, bStart) && isAfter(aEnd, bEnd) && isBefore(aStart, bEnd) && aStart.astroType === 0 && bEnd.astroType === 0) {
                            a.AstroIconStart = b.AstroIconStart;
                            a.AstroOffsetStart = b.AstroOffsetStart;
                            a.AstroTypeStart = b.AstroTypeStart;
                            a.Start = b.Start;
                            WeekProgramEntries.splice(i, 1);
                            continue;
                        }

                        ////////////////////////////////
                        // a:    ---------xxxxxx-------
                        // b:    -------------------xxxxxxxxx-------
                        // do nothing


                    }
                }

            };
            $scope.$on('entry-changed', function() {
                // Check if End is laterThan Start
                /*if(moment(a.entry.Start).isAfter(moment(a.entry.End)))
                {
                    a.entry.End = a.entry.Start  ;
                }
                */
                $scope.Condition.refresh = !$scope.Condition.refresh;
            });

            $scope.endIsBeforeStart = function(entry) {
                // var a = moment.utc(entry.Start);
                // var b = moment.utc(entry.End);
                if ((entry.AstroTypeStart !== undefined && entry.AstroTypeStart !== 0)
                    || (entry.AstroTypeEnd !== undefined && entry.AstroTypeEnd !== 0)) {
                    entry.allowSave = true;
                    return false;
                }
                if (entry.Start.isAfter(entry.End)) {
                    entry.allowSave = false;
                    return true;
                } else {
                    entry.allowSave = true;
                    return false;
                }
                //return entry.Start.isAfter(entry.End);
            };

            $scope.allowSave = () => {
                if ($scope.Condition.ConditionData.TimeProgram
                    && $scope.Condition.ConditionData.TimeProgram.WeekProgramEntries
                    && $scope.Condition.ConditionData.TimeProgram.WeekProgramEntries.length > 0) {
                        let allowSave = true;
                        $scope.Condition.ConditionData.TimeProgram.WeekProgramEntries.forEach(wpe => {
                            if (wpe.allowSave !== undefined) {
                                allowSave &= wpe.allowSave;
                            }
                        });
                        return allowSave;
                    }
                return true;
            };

            $scope.removeEntry = function(e) {
                var i = $scope.Condition.ConditionData.TimeProgram.WeekProgramEntries.indexOf(e);
                $scope.Condition.ConditionData.TimeProgram.WeekProgramEntries.splice(i, 1);
                $scope.Condition.refresh = !$scope.Condition.refresh;
            };

            function getSeekedDay(weekDay) {
                /* See: https://stackoverflow.com/a/39614998 */

                const today = moment().isoWeekday();
                const isoWeekdayINeed = weekDay;
                let dayINeed;

                // if we haven't yet passed the day of the week that I need
                if (today <= isoWeekdayINeed) {
                    // then just give me this week's instance of that day
                    dayINeed = moment().isoWeekday(isoWeekdayINeed);
                } else {
                    // otherwise, give me *next week's* instance of that same day
                    dayINeed = moment().add(1, 'weeks').isoWeekday(isoWeekdayINeed);
                }

                return dayINeed;
            }

            $scope.addEntry = function() {

                //console.log(highest);

                var e = {
                    Enabled: true,
                    Start: getSeekedDay($scope.Day.WeekDay).set(
                        {
                            'milliseconds': 0,
                            'seconds': 0,
                            'minutes': 0,
                            'hours': 0
                        }
                    ),
                    End: getSeekedDay($scope.Day.WeekDay).set(
                        {
                            'milliseconds': 0,
                            'seconds': 0,
                            'minutes': 1,
                            'hours': 0
                        }
                    ),
                    WeekDay: Day.WeekDay,
                    AstroIconStart: 'icon-zeitprogramm',
                    AstroIconEnd: 'icon-zeitprogramm',
                };

                $scope.Condition.ConditionData.TimeProgram.WeekProgramEntries.push(e);
                $scope.Condition.refresh = !$scope.Condition.refresh;
            };

            $scope.referenceDay = undefined;
            $scope.setTime = function(a, b) {

                const astroData = {
                    astroType: a['AstroType' + b],
                    astroOffset: a['AstroOffset' + b],
                    shouldActivateAstro: true,
                    weekDay: $scope.Day.WeekDay
                };
                $scope.referenceDay = getSeekedDay($scope.Day.WeekDay).set(
                    {
                        'milliseconds': 0,
                        'seconds': 0,
                        'minutes': 0,
                        'hours': 0
                    });

                let dateTimeOptionsObject = {
                    hideDate: true,
                    asUTC: false,
                    astroData: astroData
                };
                if (moment($scope.referenceDay).set({ 'milliseconds': 0, 'seconds': 0, 'minutes': 0, 'hours': 24 }).isSame(a[b])) {
                    dateTimeOptionsObject.isNextDay = true;
                    console.log('isNextDay');
                } else {
                    dateTimeOptionsObject.isNextDay = false;
                }

                dateTimePickerModal(a[b], dateTimeOptionsObject).then(function(modal) {
                    modal.close.then(function(data) {
                        if (data) {
                            let setDate;
                            if (data.AstroType === 0) {
                                setDate = data.DateTime;
                            } else {
                                let sunriseSunset = moment(data.DateTime);

                                if (moment(sunriseSunset).add(data.AstroOffset, 'minutes').isBetween(moment(sunriseSunset).startOf('day'), moment(sunriseSunset).endOf('day'), null, [])) {
                                    /* All good, offset is in allowed ranges. */
                                    sunriseSunset = moment(sunriseSunset).add(data.AstroOffset, 'minutes');

                                } else if (moment(sunriseSunset).add(data.AstroOffset, 'minutes').isBefore(moment(sunriseSunset).startOf('day'))) {
                                    /* To early, set to 00:00 */
                                    sunriseSunset = moment(sunriseSunset).set({
                                        hour: 0,
                                        minutes: 0,
                                        seconds: 0,
                                        milliseconds: 0
                                    });

                                } else if (moment(sunriseSunset).add(data.AstroOffset, 'minutes').isAfter(moment(sunriseSunset).endOf('day'))) {
                                    /* To early, set to 24:00 */
                                    sunriseSunset = moment($scope.referenceDay).set({
                                        hour: 24,
                                        minutes: 0,
                                        seconds: 0,
                                        milliseconds: 0
                                    });

                                }


                                setDate = sunriseSunset;
                            }

                            if (data.AstroType === 0) {
                                a['AstroIcon' + b] = 'icon-zeitprogramm';
                            } else if (data.AstroType === 1) {
                                a['AstroIcon' + b] = 'icon-sonnenaufgang';
                            } else if (data.AstroType === 2) {
                                a['AstroIcon' + b] = 'icon-sonnenuntergang';
                            }

                            a[b] = setDate;
                            a.ReferenceDay = moment($scope.referenceDay);

                            if (moment($scope.referenceDay).set({ 'milliseconds': 0, 'seconds': 0, 'minutes': 0, 'hours': 24 }).isSame(a[b])) {
                                a['IsNextDay' + b] = true;
                                console.log('IsNextDay' + b);
                            } else {
                                a['IsNextDay' + b] = false;
                            }

                            a['AstroType' + b] = data.AstroType;
                            a['AstroOffset' + b] = data.AstroOffset;

                            $scope.Condition.refresh = !$scope.Condition.refresh;
                        }
                    });
                });
            };
            $scope.init();

        }
    ])
    .directive('sceneTimeProgramEntry', [function() {
        'ngInject';

        return {
            scope: {
                entry: '=entry'
            },
            link: function(scope) {
                scope.$watch('entry.End', function() {
                    //scope.entry.End = scope.entry.End.replace('Z', '');
                    scope.$emit('entry-changed');
                });
                scope.$watch('entry.Start', function() {
                    //scope.entry.Start = scope.entry.Start.replace('Z', '');
                    scope.$emit('entry-changed');
                });
            }
        };


    }])
    .factory('sceneTimeProgramFineEditModal', ['ModalService', function(ModalService) {
        return function(Day, Condition, ConnectedDays) {
            return ModalService.showModal({
                templateUrl: "views/scene/modalSceneTimeProgramFineEdit.html",
                controller: 'sceneTimeProgramFineEditModalCtrl',
                inputs: {
                    Condition: Condition,
                    Day: Day,
                    ConnectedDays: ConnectedDays
                }
            });
        };
    }]);
